import PropTypes from 'prop-types';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const LeaveTabModal = props => {
  const {
    onConfirm,
    onReject
  } = props;
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settings-ui-nav.tabs.leavePage.message"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settings-ui-nav.tabs.leavePage.description"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settings-ui-nav.tabs.leavePage.confirm"
    }),
    onConfirm: onConfirm,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settings-ui-nav.tabs.leavePage.reject"
    }),
    onReject: onReject,
    size: "auto"
  });
};
LeaveTabModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};
export default LeaveTabModal;